export const DrilldownDataService = {
  // Commodity Details
  getCommodityDetails: (id) => {
    const allDetails = {
      'containerized': {
        name: 'Containerized Cargo',
        category: 'General Cargo',
        description: 'Goods shipped in standard ISO containers',
        color: '#4da6ff',
        icon: 'fas fa-box',
        current: '85,420 T',
        previous: '75,920 T',
        growth: '+12.5%',
        share: '46.1%',
        topRoutes: 'Asia-Europe, Trans-Pacific, Europe-North America',
        mainProducts: 'Electronics (32%), Apparel (28%), Machinery (22%), Pharmaceuticals (8%), Furniture (6%), Other (4%)',
        quarterlyPerformance: [
          { quarter: 'Q1 2023', volume: '231,800 T', growth: '+10.2%', revenue: '$45.2M' },
          { quarter: 'Q2 2023', volume: '248,420 T', growth: '+7.2%', revenue: '$48.5M' },
          { quarter: 'Q3 2023', volume: '255,000 T', growth: '+2.7%', revenue: '$49.8M' },
          { quarter: 'Q4 2023', volume: '265,000 T', growth: '+3.9%', revenue: '$51.7M' }
        ],
        monthlyTrend: [
          { month: 'Jan', volume: '78,420 T', change: '+5.2%' },
          { month: 'Feb', volume: '75,850 T', change: '-3.3%' },
          { month: 'Mar', volume: '82,150 T', change: '+8.3%' },
          { month: 'Apr', volume: '85,420 T', change: '+4.0%' }
        ],
        topCountries: [
          { country: 'China', volume: '25,400 T', share: '29.8%', trend: 'increasing' },
          { country: 'Germany', volume: '18,750 T', share: '22.0%', trend: 'stable' },
          { country: 'USA', volume: '15,280 T', share: '17.9%', trend: 'increasing' },
          { country: 'Japan', volume: '9,450 T', share: '11.1%', trend: 'decreasing' }
        ],
        vesselTypes: ['Container Ships (95%)', 'Multi-purpose Vessels (5%)'],
        handlingTime: 'Average 6.2 hours per vessel',
        storageDays: 'Average 4.5 days',
        valuePerTon: '$530',
        riskFactors: ['Supply chain disruptions', 'Port congestion', 'Labor strikes'],
        opportunities: ['E-commerce growth', 'Cold chain expansion', 'Digital documentation']
      },
      'dry-bulk': {
        name: 'Dry Bulk',
        category: 'Bulk Cargo',
        description: 'Unpackaged dry commodities transported in bulk',
        color: '#ff9f40',
        icon: 'fas fa-mountain',
        current: '62,150 T',
        previous: '57,420 T',
        growth: '+8.2%',
        share: '33.5%',
        topRoutes: 'Australia-Asia, South America-Europe, North America-Asia',
        mainProducts: 'Iron Ore (45%), Coal (30%), Grain (15%), Cement (6%), Fertilizer (4%)',
        quarterlyPerformance: [
          { quarter: 'Q1 2023', volume: '174,120 T', growth: '+8.5%', revenue: '$26.1M' },
          { quarter: 'Q2 2023', volume: '179,850 T', growth: '+3.3%', revenue: '$27.0M' },
          { quarter: 'Q3 2023', volume: '182,000 T', growth: '+1.2%', revenue: '$27.3M' },
          { quarter: 'Q4 2023', volume: '190,000 T', growth: '+4.4%', revenue: '$28.5M' }
        ],
        monthlyTrend: [
          { month: 'Jan', volume: '58,200 T', change: '+3.1%' },
          { month: 'Feb', volume: '59,850 T', change: '+2.8%' },
          { month: 'Mar', volume: '61,400 T', change: '+2.6%' },
          { month: 'Apr', volume: '62,150 T', change: '+1.2%' }
        ],
        topCountries: [
          { country: 'Australia', volume: '28,400 T', share: '45.7%', trend: 'increasing' },
          { country: 'Brazil', volume: '15,200 T', share: '24.5%', trend: 'stable' },
          { country: 'South Africa', volume: '8,750 T', share: '14.1%', trend: 'increasing' },
          { country: 'USA', volume: '4,300 T', share: '6.9%', trend: 'decreasing' }
        ],
        vesselTypes: ['Bulk Carriers (85%)', 'General Cargo (15%)'],
        handlingTime: 'Average 12.5 hours per vessel',
        storageDays: 'Average 3.2 days',
        valuePerTon: '$210',
        riskFactors: ['Commodity price volatility', 'Weather conditions', 'Trade restrictions'],
        opportunities: ['Infrastructure projects', 'Renewable energy materials', 'Agricultural exports']
      },
      'liquid-bulk': {
        name: 'Liquid Bulk',
        category: 'Bulk Liquid',
        description: 'Liquid commodities transported in tankers',
        color: '#ff6384',
        icon: 'fas fa-oil-can',
        current: '28,360 T',
        previous: '30,920 T',
        growth: '-8.2%',
        share: '15.3%',
        topRoutes: 'Middle East-Asia, West Africa-Europe, Russia-Europe',
        mainProducts: 'Crude Oil (60%), Chemicals (25%), LNG (10%), Vegetable Oil (5%)',
        quarterlyPerformance: [
          { quarter: 'Q1 2023', volume: '88,340 T', growth: '-5.2%', revenue: '$35.3M' },
          { quarter: 'Q2 2023', volume: '85,790 T', growth: '-2.9%', revenue: '$34.3M' },
          { quarter: 'Q3 2023', volume: '82,000 T', growth: '-4.4%', revenue: '$32.8M' },
          { quarter: 'Q4 2023', volume: '80,000 T', growth: '-2.4%', revenue: '$32.0M' }
        ],
        monthlyTrend: [
          { month: 'Jan', volume: '29,800 T', change: '-2.1%' },
          { month: 'Feb', volume: '28,900 T', change: '-3.0%' },
          { month: 'Mar', volume: '28,500 T', change: '-1.4%' },
          { month: 'Apr', volume: '28,360 T', change: '-0.5%' }
        ],
        topCountries: [
          { country: 'Saudi Arabia', volume: '12,500 T', share: '44.1%', trend: 'decreasing' },
          { country: 'Russia', volume: '6,800 T', share: '24.0%', trend: 'stable' },
          { country: 'Nigeria', volume: '4,200 T', share: '14.8%', trend: 'decreasing' },
          { country: 'USA', volume: '2,100 T', share: '7.4%', trend: 'increasing' }
        ],
        vesselTypes: ['Tankers (90%)', 'Chemical Carriers (10%)'],
        handlingTime: 'Average 8.5 hours per vessel',
        storageDays: 'Average 2.8 days',
        valuePerTon: '$410',
        riskFactors: ['Oil price fluctuations', 'Geopolitical tensions', 'Environmental regulations'],
        opportunities: ['LNG expansion', 'Chemical diversification', 'Biofuels']
      },
      'break-bulk': {
        name: 'Break Bulk',
        category: 'General Cargo',
        description: 'Goods transported individually rather than in containers',
        color: '#4cd964',
        icon: 'fas fa-cubes',
        current: '9,500 T',
        previous: '9,030 T',
        growth: '+5.2%',
        share: '5.1%',
        topRoutes: 'Regional, Short Sea Shipping, Project Cargo Routes',
        mainProducts: 'Steel (40%), Timber (25%), Project Cargo (20%), Machinery (15%)',
        quarterlyPerformance: [
          { quarter: 'Q1 2023', volume: '26,110 T', growth: '+3.5%', revenue: '$10.4M' },
          { quarter: 'Q2 2023', volume: '27,770 T', growth: '+6.4%', revenue: '$11.1M' },
          { quarter: 'Q3 2023', volume: '29,000 T', growth: '+4.4%', revenue: '$11.6M' },
          { quarter: 'Q4 2023', volume: '30,000 T', growth: '+3.4%', revenue: '$12.0M' }
        ],
        monthlyTrend: [
          { month: 'Jan', volume: '8,900 T', change: '+2.1%' },
          { month: 'Feb', volume: '9,100 T', change: '+2.2%' },
          { month: 'Mar', volume: '9,300 T', change: '+2.2%' },
          { month: 'Apr', volume: '9,500 T', change: '+2.2%' }
        ],
        topCountries: [
          { country: 'Germany', volume: '3,200 T', share: '33.7%', trend: 'increasing' },
          { country: 'Japan', volume: '2,100 T', share: '22.1%', trend: 'stable' },
          { country: 'South Korea', volume: '1,800 T', share: '18.9%', trend: 'increasing' },
          { country: 'India', volume: '1,100 T', share: '11.6%', trend: 'decreasing' }
        ],
        vesselTypes: ['General Cargo (70%)', 'Ro-Ro (20%)', 'Heavy Lift (10%)'],
        handlingTime: 'Average 18.2 hours per vessel',
        storageDays: 'Average 7.5 days',
        valuePerTon: '$680',
        riskFactors: ['Specialized handling required', 'Project delays', 'Weather sensitivity'],
        opportunities: ['Infrastructure projects', 'Wind energy components', 'Oversized cargo']
      }
    };
    
    return allDetails[id] || allDetails.containerized;
  },

  // Entity Details
  getEntityDetails: (id) => {
    const allDetails = {
      'maersk': {
        name: 'Maersk Line',
        shortName: 'M',
        parentCompany: 'A.P. Moller-Maersk',
        founded: 1904,
        headquarters: 'Copenhagen, Denmark',
        color: '#ff6384',
        marketShare: '28.5%',
        volume: '52,840 T',
        growth: '+3.2%',
        vessels: '42',
        fleetSize: '708 vessels',
        totalCapacity: '4.1M TEU',
        avgTurnaround: '18.5 hours',
        onTimePerformance: '96.2%',
        customerRating: '4.8/5',
        keyRoutes: [
          'Asia-Europe (AE1, AE7, AE10)',
          'Trans-Pacific (TP2, TP6, TP9)',
          'Asia-Middle East (ME2)',
          'Europe-South America (SA2)'
        ],
        vesselTypes: ['Container Ships (90%)', 'Multi-purpose (5%)', 'Reefer (5%)'],
        services: ['Door-to-door logistics', 'Cold chain', 'E-commerce solutions', 'Digital platform'],
        quarterlyPerformance: [
          { quarter: 'Q1 2023', volume: '155,200 T', growth: '+2.8%', revenue: '$182M' },
          { quarter: 'Q2 2023', volume: '158,500 T', growth: '+2.1%', revenue: '$186M' },
          { quarter: 'Q3 2023', volume: '159,800 T', growth: '+0.8%', revenue: '$188M' },
          { quarter: 'Q4 2023', volume: '162,000 T', growth: '+1.4%', revenue: '$191M' }
        ],
        monthlyPerformance: [
          { month: 'Jan', calls: '38', volume: '51,200 T', onTime: '95.8%' },
          { month: 'Feb', calls: '40', volume: '52,100 T', onTime: '96.1%' },
          { month: 'Mar', calls: '42', volume: '52,840 T', onTime: '96.8%' }
        ],
        financialMetrics: {
          revenue: '$7.8B (2023)',
          profitMargin: '18.2%',
          marketCap: '$56.2B',
          investment: '$2.1B in green ships'
        },
        sustainability: {
          co2Reduction: '15% since 2020',
          target: 'Net zero by 2040',
          initiatives: ['Green methanol ships', 'Carbon-neutral logistics', 'Digital optimization']
        },
        recentNews: [
          'Ordered 12 methanol-powered vessels',
          'Expanded e-commerce logistics network',
          'Launched new Asia-Europe service'
        ]
      },
      'msc': {
        name: 'Mediterranean Shipping Company',
        shortName: 'MSC',
        parentCompany: 'MSC Group',
        founded: 1970,
        headquarters: 'Geneva, Switzerland',
        color: '#ff9f40',
        marketShare: '22.3%',
        volume: '41,350 T',
        growth: '+5.1%',
        vessels: '38',
        fleetSize: '730 vessels',
        totalCapacity: '4.8M TEU',
        avgTurnaround: '19.2 hours',
        onTimePerformance: '94.7%',
        customerRating: '4.6/5',
        keyRoutes: [
          'Silk Service (Asia-Mediterranean)',
          'Jade Service (Asia-Europe)',
          'Santana Service (Asia-USWC)',
          'Dragon Service (Asia-USEC)'
        ],
        vesselTypes: ['Container Ships (92%)', 'Cruise Ships (5%)', 'Ferries (3%)'],
        services: ['Container shipping', 'Logistics', 'Terminal operations', 'Cruise line'],
        quarterlyPerformance: [
          { quarter: 'Q1 2023', volume: '120,800 T', growth: '+4.8%', revenue: '$145M' },
          { quarter: 'Q2 2023', volume: '124,100 T', growth: '+2.7%', revenue: '$149M' },
          { quarter: 'Q3 2023', volume: '126,500 T', growth: '+1.9%', revenue: '$152M' },
          { quarter: 'Q4 2023', volume: '128,000 T', growth: '+1.2%', revenue: '$154M' }
        ],
        financialMetrics: {
          revenue: '$6.2B (2023)',
          profitMargin: '16.8%',
          marketCap: 'Privately held',
          investment: '$1.8B in fleet renewal'
        },
        sustainability: {
          co2Reduction: '12% since 2020',
          target: 'Net zero by 2050',
          initiatives: ['LNG-ready vessels', 'Slow steaming', 'Port electrification']
        }
      }
    };
    
    return allDetails[id] || allDetails.maersk;
  },

  // Port Details
  getPortDetails: (id) => {
    const allDetails = {
      'port1': {
        name: 'Cohin Port',
        location: 'Cohin, India',
        established: 1928,
        operator: 'Cohin Port Authority',
        color: '#4da6ff',
        volume: '185,430 T',
        vessels: '24',
        occupancy: '82%',
        turnaround: '18.7h',
        growth: '+12.5%',
        area: '830 hectares',
        berths: '22',
        maxDraft: '14.5m',
        cranes: '45',
        storageCapacity: '1.2M TEU',
        annualCapacity: '3.5M TEU',
        keyCommodities: [
          { name: 'Containerized', share: '46.1%', volume: '85,420 T' },
          { name: 'Dry Bulk', share: '33.5%', volume: '62,150 T' },
          { name: 'Liquid Bulk', share: '15.3%', volume: '28,360 T' },
          { name: 'Break Bulk', share: '5.1%', volume: '9,500 T' }
        ],
        topShippingLines: ['Maersk (28.5%)', 'MSC (22.3%)', 'CMA CGM (18.7%)', 'COSCO (15.2%)'],
        infrastructure: {
          containerTerminals: 3,
          bulkTerminals: 2,
          liquidTerminals: 1,
          roRoTerminal: 1,
          railConnections: 8,
          truckGates: 12
        },
        services: [
          'Container handling',
          'Bulk cargo operations',
          'Liquid cargo handling',
          'Project cargo',
          'Cold storage',
          'Customs clearance'
        ],
        connectivity: {
          road: 'Connected to NH-66',
          rail: 'Dedicated freight corridor',
          air: '20km from airport',
          feeder: 'Regular feeder services'
        },
        expansionProjects: [
          { name: 'International Container Terminal', completion: '2025', capacity: '1M TEU' },
          { name: 'LNG Terminal', completion: '2024', capacity: '5M tons/year' },
          { name: 'Multimodal Logistics Park', completion: '2026', area: '200 acres' }
        ],
        performanceMetrics: {
          craneProductivity: '28.5 moves/hour',
          gateTurnaround: '24 minutes',
          vesselProductivity: '125 containers/hour',
          safetyIndex: '98.7%'
        },
        economicImpact: {
          directEmployment: '8,500',
          indirectEmployment: '25,000',
          annualRevenue: '$850M',
          tradeValue: '$42B'
        },
        environmentalInitiatives: [
          'Shore power for vessels',
          'Solar power generation',
          'Waste recycling program',
          'Water treatment plant'
        ]
      },
      'port2': {
        name: 'Kandla Port',
        location: 'Kandla, Gujarat, India',
        established: 1952,
        operator: 'Kandla Port Trust',
        color: '#ff6384',
        volume: '245,820 T',
        vessels: '32',
        occupancy: '92%',
        turnaround: '22.5h',
        growth: '+8.7%',
        description: 'Largest port by volume in India, specializing in bulk cargo'
      }
    };
    
    return allDetails[id] || allDetails.port1;
  },

  // Forecast Details
  getForecastDetails: (quarter) => {
    const allDetails = {
      'q1-2024': {
        quarter: 'Q1 2024',
        forecast: '2.05M T',
        confidence: 'High',
        growth: '+5.2%',
        previousYear: '1.95M T',
        seasonalFactor: '0.95x',
        keyDrivers: [
          'Post-holiday recovery',
          'Chinese New Year impact',
          'Winter weather patterns',
          'Agricultural season start'
        ],
        commodityBreakdown: [
          { commodity: 'Containerized', forecast: '950,000 T', growth: '+6.8%' },
          { commodity: 'Dry Bulk', forecast: '720,000 T', growth: '+4.2%' },
          { commodity: 'Liquid Bulk', forecast: '280,000 T', growth: '+1.8%' },
          { commodity: 'Break Bulk', forecast: '100,000 T', growth: '+5.5%' }
        ],
        riskFactors: [
          { factor: 'Weather disruptions', probability: 'Medium', impact: 'High' },
          { factor: 'Labor negotiations', probability: 'Low', impact: 'Medium' },
          { factor: 'Fuel price volatility', probability: 'High', impact: 'Medium' }
        ],
        opportunities: [
          'New trade agreements',
          'E-commerce growth',
          'Infrastructure spending'
        ]
      }
    };
    
    return allDetails[quarter] || allDetails['q1-2024'];
  },

  // Trade Details
  getTradeDetails: (country) => {
    const allDetails = {
      'china': {
        country: 'China',
        import: '42,500 T',
        export: '15,200 T',
        balance: -27300,
        totalTrade: '57,700 T',
        tradeShare: '31.1%',
        topImports: [
          'Electronics (35%)',
          'Machinery (28%)',
          'Apparel (22%)',
          'Toys (8%)',
          'Furniture (7%)'
        ],
        topExports: [
          'Iron Ore (45%)',
          'Coal (25%)',
          'Agricultural Products (20%)',
          'Minerals (10%)'
        ],
        monthlyTrend: [
          { month: 'Jan', imports: '40,200 T', exports: '14,800 T', balance: -25400 },
          { month: 'Feb', imports: '41,500 T', exports: '14,900 T', balance: -26600 },
          { month: 'Mar', imports: '42,100 T', exports: '15,100 T', balance: -27000 },
          { month: 'Apr', imports: '42,500 T', exports: '15,200 T', balance: -27300 }
        ],
        majorPorts: ['Shanghai', 'Shenzhen', 'Ningbo-Zhoushan', 'Guangzhou'],
        shippingLines: ['COSCO (40%)', 'Maersk (25%)', 'MSC (20%)', 'Others (15%)'],
        tradeAgreements: ['ASEAN-China FTA', 'RCEP'],
        futureOutlook: 'Expected import growth of 8-10% in 2024'
      }
    };
    
    return allDetails[country] || allDetails.china;
  }
};